export default {
    namespaced: true,
    state: () => ({
        country: '',
        ipversion: '',
        protocol: '',
        authtype: '',
        package: '',
        quantity: 1,

        ipwhitelist: [],
        months: '',
        isp: '',
        bandwidth: 1,
        region: '',

        billing: '',

    }),
    mutations:
    {
        SET_COUNTRY(state, val) {
            state.country = val
        },
        SET_IPVERSION(state, val) {
            state.ipversion = val
        },
        SET_PROTOCOL(state, val) {
            state.protocol = val
        },
        SET_AUTHTYPE(state, val) {
            state.authtype = val
        },
        SET_PACKAGE(state, val) {
            state.package = val
        },
        SET_QUANTITY(state, val) {
            state.quantity = val
        },
        SET_IPWHITELIST(state, val) {
            state.ipwhitelist = val
        },
        SET_MONTHS(state, val) {
            state.months = val
        },
        SET_ISP(state, val) {
            state.isp = val
        },
        SET_BW(state, val) {
            state.bandwidth = val
        },
        SET_REGION(state, val) {
            state.region = val
        },
        SET_BILLING(state, val) {
            state.billing = val
        }
    }
}